import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { GROUPED_BY } from "@constants"
import { commonFiltersValue, groupedBy, isLoadingCommonFilters } from "@signals"
import { useSkuDetailsRoleConfig } from "../../@hooks"
import { skuDetailsScores, skuDetailsScoresInLoading } from "../../@signals"


export default function useSkuDetailsPricingData() {

	const { urlApiPricing } = useSkuDetailsRoleConfig()

	const isLoadingPricing = useSignal(false)
	const data = useSignal([])
	const pricingGroupBy = useSignal([GROUPED_BY.COUNTRY])

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoadingPricing.value = true
			data.value = []
			postSubmit(urlApiPricing, { ...commonFiltersValue.value, groupedBy: pricingGroupBy.value }).then(res => batch(() => {
				data.value = res.data
                skuDetailsScores.value["Pricing"] = res.pricingScore
			})).finally(() => batch(() => {
				isLoadingPricing.value = false
			}))
		}
	}, [isLoadingCommonFilters.value])

	const handleChangeGroupBy = (e) => {
		groupedBy.value = e.target.value

		if (groupedBy.value === GROUPED_BY.COUNTRY)
			pricingGroupBy.value = [GROUPED_BY.COUNTRY]

		if (groupedBy.value === GROUPED_BY.RETAILER)
			pricingGroupBy.value = [GROUPED_BY.COUNTRY, GROUPED_BY.RETAILER]

		isLoadingPricing.value = true
		data.value = []
		postSubmit(urlApiPricing, { ...commonFiltersValue.value, groupedBy: pricingGroupBy.value }).then(res => batch(() => {
			data.value = res.data
		})).finally(() => batch(() => {
			isLoadingPricing.value = false
		}))
	}

	useEffect(() => {
		if (isLoadingPricing.value) {
			skuDetailsScoresInLoading.value = [...skuDetailsScoresInLoading.value, "Pricing"]
		} else {
			skuDetailsScoresInLoading.value = skuDetailsScoresInLoading.value.filter(item => item !== "Pricing")
		}
	}, [isLoadingPricing.value])

	return {
		isLoadingPricing: isLoadingPricing.value,
		data: data.value,
		
		handleChangeGroupBy
	}
}